export function getCookieValue(name: string) {
  if (typeof document === "undefined") return null;

  const cookie = document.cookie
    .split(";")
    .map((row) => row.trim())
    .find((row) => row.startsWith(`${encodeURIComponent(name)}=`));

  if (!cookie) return null;

  const rawValue = cookie.slice(cookie.indexOf("=") + 1);

  try {
    return decodeURIComponent(rawValue);
  } catch {
    return rawValue;
  }
}

export type VisitorContext = {
  visitorIp?: string | null;
};

export function getPageUriWithoutQuery() {
  if (typeof window === "undefined") return null;

  return `${window.location.origin}${window.location.pathname}`;
}

function isLocalBrowserHost() {
  if (typeof window === "undefined") return false;

  return ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname);
}

export async function getVisitorContext(signal?: AbortSignal): Promise<VisitorContext> {
  if (process.env.NODE_ENV === "development" && isLocalBrowserHost()) {
    return { visitorIp: null };
  }
  if (typeof fetch === "undefined") return { visitorIp: null };

  try {
    const response = await fetch("/api/visitor-context", {
      headers: {
        Accept: "application/json",
      },
      cache: "no-store",
      signal,
    });

    if (!response.ok) return { visitorIp: null };

    const data = await response.json();
    const visitorIp =
      typeof data?.visitorIp === "string" && data.visitorIp.trim()
        ? data.visitorIp.trim()
        : null;

    return { visitorIp };
  } catch {
    return { visitorIp: null };
  }
}

export function getTrackingPayload(visitorContext: VisitorContext = {}) {
  const hutk = getCookieValue("hubspotutk");

  return {
    hutk,
    hubspotutk: hutk,
    visitorIp: visitorContext.visitorIp ?? null,
    pageUri: getPageUriWithoutQuery(),
    pageName: typeof document !== "undefined" ? document.title : null,
  };
}
